export default __webpack_public_path__ + "static/8_23-accf9673b6ff14fa2bcb664acaac08dd.png";